import ApiService from "../../api/api";
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            form: {
                button_text: '',
                description: '',
                external_links: '',
                published: true,
                logo: null,
                background: null,
                filter_for_background: false
            }
        };
    },
    getters: {
        form: (state) => {
            return state.form
        },
    },
    mutations: {
        setForm(state, form) {
            state.form = form;
        },
    },
    actions: {
        createBanner({state, commit}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.post('/banner', payload)
                    .then((response) => {
                        commit('setForm', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        editBanner({state, commit}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.update('/banner/'+payload.id, payload)
                    .then((response) => {
                        commit('setForm', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    }
}